document.querySelectorAll('.video-social-carousel__video').forEach((video) => {
  video.play().catch(() => {});
});

if ('IntersectionObserver' in window) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    },
    { threshold: 0.25 }
  );

  document.querySelectorAll('.video-social-carousel__video').forEach((video) => {
    observer.observe(video);
  });
}
